const copyrightLocales = {
  allRightsReserved: {
    ar: "جميع الحقوق محفوظة.",
    en: "All rights reserved.",
  },
  copyright: {
    ar: "©",
    en: "©",
  },
  crescentApplications: {
    ar: "تطبيقات الهلال ش.ذ.م.م.",
    en: "Crescent Applications LLC.",
  },
};

export default copyrightLocales;
